import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Dynamically Injecting Corporate Document Head Attributes & Metadata
if (typeof document !== 'undefined') {
  // 1. Establish Official Legal Entity Corporate Title
  document.title = "VAMCO Architectural Prospective Drawings Services LLC | Rebar Detailing & BBS Experts";

  // 2. Configure Dynamic Favicon Asset Link
  let faviconLink = document.querySelector("link[rel~='icon']");
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    document.head.appendChild(faviconLink);
  }
  // Point this path to your favicon file inside your public folder (e.g., /favicon.ico or /logo.png)
  faviconLink.href = "/favicon.ico"; 

  // 3. Inject Critical Meta Headers for SEO and Engineering Compliance
  const metaDescriptions = [
    { name: "description", content: "Premier engineering partner in Dubai specialized in structural Rebar Detailing, precise Bar Bending Schedules (BBS), high-precision estimation, and 3D clash coordination workflows across the UAE." },
    { name: "keywords", content: "VAMCO UAE, Rebar Detailing Dubai, Bar Bending Schedule BBS, Shop Drawings Business Bay, Structural Coordination, Code-Compliant Engineering Drawings" },
    { name: "author", content: "VAMCO LLC-UAE" },
    // Open Graph Corporate Layout Headers (For professional B2B platform link previews like LinkedIn)
    { property: "og:title", content: "VAMCO Architectural Prospective Drawings Services LLC" },
    { property: "og:description", content: "High-precision, code-compliant Rebar Shop Drawings and Bar Bending Schedules optimized for premium Middle East structural fabrication portfolios." },
    { property: "og:type", content: "website" },
    { property: "og:image", content: "/images/og-corporate-preview.jpg" }
  ];

  metaDescriptions.forEach(tagData => {
    const selector = tagData.name ? `meta[name='${tagData.name}']` : `meta[property='${tagData.property}']`;
    let metaTag = document.querySelector(selector);
    if (!metaTag) {
      metaTag = document.createElement('meta');
      if (tagData.name) metaTag.name = tagData.name;
      if (tagData.property) metaTag.setAttribute('property', tagData.property);
      document.head.appendChild(metaTag);
    }
    metaTag.content = tagData.content;
  });
}

// Main React App Root Render Cascade
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);